"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const account_groups_1 = require("companion-app-components/flux/account-groups");
const actions = __importStar(require("companion-app-components/flux/account-groups/accountGroupsActions"));
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const accountGroupUtils_1 = require("companion-app-components/flux/account-groups/accountGroupUtils");
const authSelectors_1 = require("companion-app-components/flux/auth/authSelectors");
const accountGroupsTypes_1 = require("companion-app-components/flux/account-groups/accountGroupsTypes");
function* getAccountGroupsSuccessWatcher() {
    yield (0, effects_1.takeEvery)(actions.getAccountGroupsSuccess, function* handlegetAccountGroupsSuccess() {
        var _a;
        const selectedGroupName = yield (0, effects_1.select)(accountGroupsSelectors_1.getCurrentAccountGroupName);
        const dataset = yield (0, effects_1.select)(authSelectors_1.getCurrentDataset);
        const sharedAccountGroups = yield (0, effects_1.select)(accountGroupsSelectors_1.selectSharedAccountGroup);
        const allAccountGroups = yield (0, effects_1.select)(accountGroupsSelectors_1.getAccountGroups);
        const savedEntityInLS = localStorage.getItem(accountGroupsTypes_1.LS_KEY_SELECTED_ENTITY);
        const accountGroups = (dataset === null || dataset === void 0 ? void 0 : dataset.shared) ? sharedAccountGroups : allAccountGroups;
        const predefinedGroups = [accountGroupsTypes_1.ALL_ACCOUNT_GROUPS, accountGroupsTypes_1.UN_ASSIGNED_ACCOUNTS];
        const selectedEntityName = ((_a = accountGroups === null || accountGroups === void 0 ? void 0 : accountGroups.find(({ id }) => savedEntityInLS === id)) === null || _a === void 0 ? void 0 : _a.name) || '';
        let nextSelectedGroupName;
        if (selectedEntityName) {
            nextSelectedGroupName = selectedEntityName;
        }
        else if (savedEntityInLS &&
            (!(dataset === null || dataset === void 0 ? void 0 : dataset.shared) || (0, accountGroupUtils_1.hasFullDatasetAccess)(dataset)) &&
            predefinedGroups.includes(savedEntityInLS)) {
            nextSelectedGroupName = savedEntityInLS;
        }
        else {
            // Check user has access to the selected group
            const hasSelectedGroupName = accountGroups === null || accountGroups === void 0 ? void 0 : accountGroups.find(({ name }) => selectedGroupName === name);
            if (hasSelectedGroupName) {
                nextSelectedGroupName = selectedGroupName;
            }
            else {
                nextSelectedGroupName = (0, accountGroupUtils_1.getDefaultAccountGroupName)(accountGroups, dataset);
            }
        }
        if (nextSelectedGroupName) {
            yield (0, effects_1.put)(actions.selectAccountGroup(nextSelectedGroupName));
        }
    });
}
exports.default = [
    ...account_groups_1.accountGroupsSagas,
    getAccountGroupsSuccessWatcher,
];
